<template>  
    <div id="TransmisionEnVivo_div" class="w-100 px-5 py-4">
      <div id="TituloTransmisionEnVivo_div">
        <h1 style="margin-bottom: 0px;">PANEL DE AUDIENCIAS POR VERIFICAR</h1>
        <h3 style="margin-top: 0px;">Control de audiencias pendientes de verificar</h3>
      </div>
      <div class="row d-flex">
        <div id="BusquedaPanelDeAudienciasPorVerificar_div" class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <FiltrosDeBusqueda :catalogos="catalogos" :ejecutaLaFuncion="cargaAudienciasPorVerificar"></FiltrosDeBusqueda>
          </div>
        </div>
        <div id="ContenidoPanelDeAudienciasPorVerificar_div" class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area">
            <h4>Audiencias encontradas</h4>
            <h6>Seleccione la audiencia a trabajar</h6>
            <hr />
            <div id="PanelDeAudienciasPorVerificar_table" class="table-responsive">
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">Fecha y Hora</th>
                    <th class="text-center">Tipo de Documento</th>
                    <th class="text-center">Consecutivo</th>
                    <th class="text-center">Partido Judicial</th>
                    <th class="text-center">Juzgado</th>
                    <th class="text-center">Materia</th>
                    <th class="text-center">Tipo de Audiencia</th>
                    <th class="text-center">Sala</th>
                    <th class="text-center">Juez</th>
                    <th class="text-center">Operador</th>
                    <th class="text-center">Estatus</th>
                    <th class="text-center"></th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="audienciasPorVerificar.length <= 0">
                    <td colspan="13" class="text-center">No existen registros de audiencias por verificar</td>
                  </tr>
                  <tr v-for="audienciaPorVerificar in audienciasPorVerificar">
                    <td v-html="obtenFechaDeAudienciaConFormato(audienciaPorVerificar.FechaAudiencia)" style="width: 100px;"></td>
                    <td>{{audienciaPorVerificar.TipoDocumento.Nombre}}</td>
                    <td class="text-center">{{audienciaPorVerificar.Consecutivo}}</td>
                    <td class="text-center">{{audienciaPorVerificar.PartidoJudicial.Nombre}}</td>
                    <td>{{audienciaPorVerificar.Area.Nombre}}</td>
                    <td>{{audienciaPorVerificar.Materia.Nombre}}</td>
                    <td class="text-center">{{audienciaPorVerificar.TipoAudiencia.Nombre}}</td>
                    <td class="text-center">{{audienciaPorVerificar.Sala.Nombre}}</td>
                    <td class="text-center" v-if="audienciaPorVerificar.JuecesEnAudiencia.length === 0">SIN JUEZ</td>
                    <td class="text-center" v-if="audienciaPorVerificar.JuecesEnAudiencia.length > 0"><p v-for="juez in audienciaPorVerificar.JuecesEnAudiencia">{{juez.Juez.Nombre}} {{juez.Juez.ApellidoPaterno}} {{juez.Juez.ApellidoMaterno}}</p></td>
                    <td>{{audienciaPorVerificar.Usuario_OperadorDeSala.Nombre}}</td>
                    <td class="text-center">{{audienciaPorVerificar.TipoEstatusDeAudiencia.Nombre}}</td>
                    <td class="text-center">                      
                      <a v-if="audienciaPorVerificar.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 6" v-on:click="verificarAudiencia(audienciaPorVerificar.AudienciaId)" title="Verificar audiencia">
                        <i class="fas fa-tasks"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>  
</template>

<script>
  //Importaciones estandarizadas  
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import sistemas from '@/../static/js/sistemas'
  import api from '@/../static/js/api'
  import router from '@/router/index'
  import axios from 'axios'

  export default {
    components: {
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda
    },
    data() {
      return {
        comun,
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.FechaDeInicio },
          { catalogoId: enumeraciones.catalogos.FechaFinal },          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Salas, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Jueces, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione }
        ],
        audienciasPorVerificar: []
      }
    },
    mounted() {
      //this.cargaAudienciasPorVerificar();
    },
    methods: {      
      verificarAudiencia: function (audienciaId) {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Desea verificar la audiencia?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Verificar'
            }
          },
          callback: function (respuesta) {
            if (respuesta) {
              router.push({ name: "EdicionYAsignacion", params: { AudienciaId: audienciaId } });
            }
          }
        });
      },      
      obtenFechaDeAudienciaConFormato: function (fechaDeAudiencia) {
        return moment(fechaDeAudiencia).format("DD-MM-YYYY <br /> h:mm a")
      },
      cargaAudienciasPorVerificar: function () {
        if(this.validaParametros())
        {
        comun.SeEstaCargandoInformacion(true);
        const parametros = {
          FechaInicial: this.$store.state.Comun_FechaInicial,
          FechaFinal: this.$store.state.Comun_FechaFinal,          
          PartidoJudicialId: this.$store.state.PJ_Catalogos_009PartidosJudiciales['filtroDeBusqueda_PartidoJudicial'],
          MateriaId: this.$store.state.PJ_Catalogos_002Materias['filtroDeBusqueda_Materia'],
          AreaId: this.$store.state.PJ_Catalogos_001Areas['filtroDeBusqueda_Area'],
          SalaId: this.$store.state.PJ_Catalogos_020Salas['filtroDeBusqueda_Sala'],
          JuezId: this.$store.state.PJ_Catalogos_009PartidoJudicialId,
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.ObtenAudienciasPorVerificar,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {          
          if (respuesta.data.SiHayError) {
            console.log(respuesta);            
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            this.audienciasPorVerificar = [];
          } else {            
            this.audienciasPorVerificar = respuesta.data.AudienciasPorVerificar;
          }

          comun.SeEstaCargandoInformacion(false);
        }
        ).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
          this.audienciasPendientes = [];
        });
        }
      },
      validaParametros(){
        if(this.$store.state.PJ_Catalogos_009PartidosJudiciales['filtroDeBusqueda_PartidoJudicial'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione un Partido Judicial.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_002Materias['filtroDeBusqueda_Materia'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione una Materia.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_001Areas['filtroDeBusqueda_Area'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione un Juzgado.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_020Salas['filtroDeBusqueda_Sala'] == -1)
        {
          comun.mensajeDeAlerta("Seleccione una Sala.", null, null);
          return false
        };

        return true;
      }
    }
  }
</script>

<style>
  .padding-div-low {
    padding-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/PanelDeAudienciasPorVerificar/PanelDeAudienciasPorVerificar.vue